




































































































import { MailMagazineManagementService as mailMagazineApi } from "@/common/api";
import QNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import MagazinesDetailComponent from "@/components/admin/magazines/magazinesDetailComponent.vue";
import MagazinesEditComponent from "@/components/admin/magazines/magazinesEditComponent.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import { STATUS, STATUS_NAME, TYPES, TYPES_ARRAY } from "@/model/mailMagazine";
import PaginateModel from "@/model/paginate";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MagazinesListComponent",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    MagazinesEditComponent,
    MagazinesDetailComponent,
    QMultiSelect,
  },
})
export default class MagazinesListComponent extends Vue {
  public mailMagazines = [];
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public headers = [];

  public initHeaders = [
    { id: "post_date", name: "送信日時", order: "desc" },
    { id: "created_by", name: "送信者", order: "" },
    { id: "type", name: "対象者", order: "" },
    { id: "title", name: "件名" },
    { id: "open_status", name: "状態", order: "" },
    { id: "", name: "" },
  ];

  public initSearch = {
    types: ["all_option"],
    userId: ["all"],
    keyword: null,
    sort: "post_date",
    direction: "desc",
    perPage: 30,
    currentPage: 1,
  };

  public senders = [];

  public searchParams: any = {};

  public selectedAllType = { id: "all_option", name: "すべての対象者" };
  public searchTypeOptions = [...[this.selectedAllType], ...TYPES_ARRAY];
  public selectedAllSender = { id: "all", name: "すべての送信者" };
  get searchSenderOption() {
    return [...[this.selectedAllSender], ...this.senders];
  }

  public typeArray = [TYPES.ALL, TYPES.CONSUMER, TYPES.BUSINESS, TYPES.MANIA];

  public async mounted() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    await this.getSearchParams();
    this.initalSearch();
    this.filterData();
  }

  public initalSearch(): void {
    let query = this.$router.currentRoute.query;
    query = this.formatQueryToArray(query, "types");
    query = this.formatQueryToArray(query, "userId");
    this.searchParams = {
      ...this.initSearch,
      ...query,
    };
  }

  public async getSearchParams() {
    const result = await mailMagazineApi.adminMailMagazineSender({});
    const senders = result.data.senders.map((item) => {
      return {
        id: item.id.toString(),
        name: item.name,
      };
    });
    this.senders = senders;
  }

  public formatQueryToArray(query, name) {
    if (query[name]) {
      query[name] = Array.isArray(query[name]) ? query[name] : [query[name]];
    }
    return query;
  }

  public filterData(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }
    query = {
      ...this.searchParams,
      ...query,
      ...addition,
    };

    this.$router
      .replace({ name, params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    if (
      query.sort == "type" &&
      (Object.keys(query.types).length === 0 ||
        query.types.includes("all_option"))
    ) {
      query.types = [TYPES.ALL, TYPES.CONSUMER, TYPES.BUSINESS, TYPES.MANIA];
    }
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    let message: any;
    try {
      if (query.types && query.types.includes("all_option")) {
        query.types = [];
      }

      if (query.userId && query.userId.includes("all")) {
        query.userId = [];
      }
      const result = await mailMagazineApi.adminMailMagazine(query);
      this.pagination = new PaginateModel({
        page: result.data.paginator.currentPage,
        pageCount: result.data.paginator.lastPages,
        start: result.data.paginator.currentPage,
        end: result.data.paginator.lastPages,
        count: result.data.paginator.total,
      });
      this.mailMagazines = result.data.mailMagazine;
    } catch (error) {
      message = error.body.messages;
      QNotify.error({
        text: message,
      });
    }
  }

  public clear() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.$router.replace({ query: {} });
    this.doSearch();
  }

  public resetSearch() {
    this.clearSearchParams();
    this.filterData(true);
  }

  public clearSearchParams() {
    this.searchParams = { ...this.initSearch };
  }

  public isSent(mailMagazine) {
    return mailMagazine.status_name === STATUS_NAME[STATUS.SEND];
  }

  public showDetail(mailMagazine, isClone = false) {
    if (this.isSent(mailMagazine) && !isClone) {
      this.showDetailPopup(mailMagazine);
    } else {
      this.showEditPopup(mailMagazine, isClone);
    }
  }

  public showEditPopup(mailMagazine = null, isClone = false) {
    (this.$refs.MagazinesEditComponentPopup as MagazinesEditComponent).show(
      mailMagazine ? mailMagazine.id : null,
      isClone,
    );
  }

  public showDetailPopup(mailMagazine) {
    (this.$refs.MagazinesDetailComponentPopup as MagazinesDetailComponent).show(
      mailMagazine,
    );
  }

  public handleMultiSelectInput(selection) {
    this.searchParams.types = this.typeArray.filter((option) =>
      selection.includes(option),
    );
  }
}
